// @ts-nocheck
import axios from 'config/api';
import { API_DJANGO, API } from 'config/constants';
const platform = import.meta.env.VITE_PLATFORM;

const config = platform === 'django' ? API_DJANGO : API;

export const api = axios.create(config);

export const authenticated = (apiInstance) => {
  const token = localStorage.getItem('token');
  const tenant = localStorage.getItem('tenant');

 
  // eslint-disable-next-line no-param-reassign
  apiInstance.defaults.headers.common.Authorization = `Bearer ${token}`;
  // eslint-disable-next-line no-param-reassign
  apiInstance.defaults.headers.common['tenant-id'] = tenant;

  return apiInstance;
};
